import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { REVIEWS } from "../../data/content";
import { Reveal } from "../../lib/motion";

export const Reviews = () => {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(0);

  const go = (n) => {
    setDir(n);
    setI((prev) => (prev + n + REVIEWS.length) % REVIEWS.length);
  };

  const r = REVIEWS[i];

  return (
    <section id="reviews" className="py-24 lg:py-36 bg-sage-dark text-cream overflow-hidden" aria-labelledby="reviews-heading">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <Reveal><p className="overline text-sage-light mb-6">Kind words</p></Reveal>
        <Reveal delay={0.05}>
          <h2 id="reviews-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Trusted by clients across Swindon.
          </h2>
        </Reveal>

        <div className="mt-14 lg:mt-16 relative min-h-[280px] flex items-center justify-center">
          <Quote size={60} className="absolute -top-4 left-1/2 -translate-x-1/2 text-sage-light/25" strokeWidth={1} />
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={i}
              custom={dir}
              initial={{ opacity: 0, x: dir >= 0 ? 60 : -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir >= 0 ? -60 : 60 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="review-quote"
              className="max-w-3xl"
            >
              <p className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-snug italic text-cream">
                “{r.quote}”
              </p>
              <footer className="mt-8 text-sage-light">
                <span className="text-base font-medium not-italic">{r.author}</span>
                <span className="mx-2 text-sage-light/50">·</span>
                <span className="text-base">{r.location}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-5">
          <button
            onClick={() => go(-1)}
            data-testid="review-prev"
            aria-label="Previous review"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-light/30 hover:bg-sage-light/15 transition-colors duration-300"
          >
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {REVIEWS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => { setDir(idx > i ? 1 : -1); setI(idx); }}
                aria-label={`Go to review ${idx + 1}`}
                className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-cream" : "w-2 bg-sage-light/40"}`}
              />
            ))}
          </div>
          <button
            onClick={() => go(1)}
            data-testid="review-next"
            aria-label="Next review"
            className="flex h-12 w-12 items-center justify-center rounded-full border border-sage-light/30 hover:bg-sage-light/15 transition-colors duration-300"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
